// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_eK","catalogByServiceItem__title":"c-k_eL"};